import React, { FunctionComponent, useCallback } from 'react';
import { FlybuysStep as CommonFlybuysStep } from 'scenes/common/components/Steps';
import {
  hasFlybuys,
  getFlybuysNumber,
  hasQuoteNumberFromSuccessfulCall,
  getSelectedCoverType,
} from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import { skipPromoPage } from 'scenes/motor/helpers/campaign';
import { FunnelType } from 'scenes/common/types';

const FlybuysStep: FunctionComponent<
  MotorFullPageProps & {
    hasQuoteNumber?: boolean;
    onSubmitQuoteAnalytics?: () => void;
  }
> = ({
  onNext,
  onCreateQuote,
  onUpdateQuoteDetails,
  onSubmitQuoteAnalytics,
  funnelState,
  onUpdateFlybuys,
}) => {
  const onSubmitToCreateQuote = useCallback(() => {
    if (onSubmitQuoteAnalytics) {
      onSubmitQuoteAnalytics();
    }
    if (hasQuoteNumberFromSuccessfulCall(funnelState)) {
      onUpdateQuoteDetails();
    } else {
      onCreateQuote();
    }
  }, [
    funnelState,
    onCreateQuote,
    onSubmitQuoteAnalytics,
    onUpdateQuoteDetails,
  ]);

  const onSubmit = useCallback(
    (values) => {
      onNext(values);
    },
    [onNext]
  );

  return (
    <CommonFlybuysStep
      onSubmit={skipPromoPage ? onSubmitToCreateQuote : onSubmit}
      defaultHasFlybuysStateValue={hasFlybuys(funnelState)}
      defaultFlybuysNumberStateValue={getFlybuysNumber(funnelState)}
      submitButtonCaption={skipPromoPage ? 'Get your quote' : 'Next'}
      onUpdateFlybuys={onUpdateFlybuys}
      coverType={getSelectedCoverType(funnelState)}
      productType={FunnelType.Motor}
    />
  );
};

export default FlybuysStep;
